import {
  diff as rawDiff,
  intersection as rawIntersection,
  union as rawUnion,
  xor as rawXor,
} from 'martinez-polygon-clipping';
import {
  createSafeMartinezClipOp,
  type MartinezClipOp,
} from './martinez-polygon-clipping.helpers';

/**
 * Safe Martinez `union` for Vite/ESM app code (client and vitest).
 * The API and migrations must not import this file. Node `require` and the API
 * webpack bundle select the package CJS build, which throws
 * `default is not a constructor`. Load it with
 * `await import('martinez-polygon-clipping')` and {@link createSafeMartinezClipOp}.
 */
export const safeMartinezUnion: MartinezClipOp = createSafeMartinezClipOp(
  'union',
  rawUnion,
);

/**
 * Safe Martinez `diff` for Vite/ESM app code.
 */
export const safeMartinezDiff: MartinezClipOp = createSafeMartinezClipOp(
  'diff',
  rawDiff,
);

/**
 * Safe Martinez `intersection` for Vite/ESM app code.
 */
export const safeMartinezIntersection: MartinezClipOp =
  createSafeMartinezClipOp('intersection', rawIntersection);

/**
 * Safe Martinez `xor` for Vite/ESM app code.
 */
export const safeMartinezXor: MartinezClipOp = createSafeMartinezClipOp(
  'xor',
  rawXor,
);
